import React, { useMemo } from 'react';
import PrimarySelect from '@components/common/Select';
import useContainerRef from '@src/hooks/utils/useContainerRef';

const orderedSort = (unorderedList, orderedList) => {
  unorderedList.sort((a, b) => orderedList.indexOf(a) - orderedList.indexOf(b));
};

function MetricDropdown({
  metrics,
  order = null,
  selectedMetric,
  onChange,
  disabled = false,
  size = 'middle',
}) {
  const options: any = useMemo(() => {
    const optList = Object.values(metrics).map((metric: any) => ({
      value: metric.name,
      label: `${metric.displayName} ${metric.subscript ? metric.subscript : ''}`,
    }));

    if (order) {
      orderedSort(optList, order);
    }

    return optList;
  }, [metrics, order]);

  const { containerRef, getContainer }: any = useContainerRef();

  const selectedValue = selectedMetric in metrics ? selectedMetric : '';
  return (
    <div ref={containerRef}>
      <PrimarySelect
        showSearch
        optionFilterProp="label"
        options={options}
        onChange={onChange}
        value={selectedValue}
        style={{ width: 'fit-content', maxWidth: 300, minWidth: 100 }}
        styles={{ popup: { root: { minWidth: 300 } } }}
        variant="borderless"
        disabled={disabled}
        size={size}
        getPopupContainer={getContainer}
      />
    </div>
  );
}

export default MetricDropdown;
